import styled, { css } from 'styled-components';
import { gridSizes, textSizes, zIndexses } from 'utils/style';

export default styled.div`
  font-size: ${textSizes('M')};
  line-height: normal;
  position: absolute;

  background-color: var(--blue-night-shadow);
  border-radius: 3px;
  color: #fff;
  padding: ${gridSizes('S')};
  transform: translateY(calc(-100% - 7px - 5px));
  z-index: ${zIndexses.fieldError};
  top: 0;
  width: 350px;

  ${(props) =>
    props.growLeft &&
    css`
      transform: translateY(calc(-100% - 7px - 5px)) translateX(-250px);
    `}

  ${(props) =>
    props.growMiddle &&
    css`
      transform: translateY(calc(-100% - 7px - 5px)) translateX(-150px);
    `}

  &:before {
    content: '';
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 7px ${gridSizes('S')} 0 ${gridSizes('S')};
    border-color: var(--blue-night-shadow) transparent transparent transparent;
    position: absolute;
    left: ${gridSizes('S')};
    bottom: -7px;
    ${(props) =>
      props.growLeft &&
      css`
        transform: translateX(250px);
      `}
    ${(props) =>
      props.growMiddle &&
      css`
        transform: translateX(150px);
      `}
  }
`;
